import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';

export function formatDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString();
}

export function labelize(value) {
  const normalized = String(value || '').trim();
  if (!normalized) return '—';
  return normalized
    .split(/[_-]+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function statusColor(status) {
  switch (String(status || '').toLowerCase()) {
    case 'active':
    case 'published':
    case 'succeeded':
    case 'ready':
    case 'in_sync':
    case 'verified':
      return 'success';
    case 'failed':
    case 'error':
    case 'blocked':
      return 'error';
    case 'needs_attention':
    case 'needs_auth':
    case 'waiting':
    case 'paused':
    case 'out_of_sync':
      return 'warning';
    case 'running':
    case 'publishing':
    case 'queued':
    case 'planned':
      return 'primary';
    default:
      return 'default';
  }
}

export function StatusChip({ status, label, ...props }) {
  const color = statusColor(status);
  return (
    <Chip
      size="small"
      color={color}
      variant={color === 'default' ? 'outlined' : 'filled'}
      label={label || labelize(status)}
      {...props}
    />
  );
}

export function ProviderChips({ providers }) {
  const values = Array.from(new Set((providers || []).filter(Boolean)));
  if (!values.length) return <Typography variant="body2" color="text.secondary">—</Typography>;
  return (
    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
      {values.map((provider) => <Chip key={provider} size="small" variant="outlined" label={labelize(provider)} />)}
    </Stack>
  );
}

export function publicationHealth(publication) {
  if (!publication) return 'unknown';
  if (publication.last_error) return 'needs_attention';
  if (['active', 'published', 'in_sync'].includes(publication.status) && publication.last_verified_at) return 'verified';
  if (['failed', 'blocked', 'needs_attention'].includes(publication.status)) return 'needs_attention';
  if (publication.external_id && !publication.last_verified_at) return 'out_of_sync';
  return publication.status || 'draft';
}
